var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"shrink app-sidebar app-sidebar-left"},[(!_vm.$store.state.showArticleOnly)?_c('SearchForm'):_vm._e(),_c('ContactBannerNew'),_c('MainShare'),(['homewlang', 'home'].includes(_vm.$route.name) || !!_vm.$route.name)?_c('DynamicAutoHeightInfoBox',{attrs:{"show-indexes":['homewlang', 'home'].includes(_vm.$route.name)
        ? [1, 2, 3, 4, 5, 6, 7]
        : [1, 3]}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }